import log, { LogLevelDesc } from 'loglevel';
import dayjs from 'dayjs';

import { env } from 'env';

const { REACT_APP_LOG_LEVEL = log.levels.DEBUG } = env;

const originalFactory = log.methodFactory;
log.noConflict();
log.setLevel(REACT_APP_LOG_LEVEL as LogLevelDesc);

log.methodFactory = (methodName, logLevel, loggerName) => {
  return (message, rest) => {
    const name = loggerName ? String(loggerName) : 'default';
    const date = dayjs().format('YYYY-MM-DD HH:mm:ss');

    const finalMessage = [`[${date}]`, `[${name}]`, message].join(' ');

    if (rest) {
      originalFactory(methodName, logLevel, loggerName)(finalMessage, rest);
    }
    originalFactory(methodName, logLevel, loggerName)(finalMessage);
  };
};

const MytaverseLogger = log.getLogger('Mytaverse');

export default log;
export { MytaverseLogger };
